import axios from "axios";
import {useHistory} from "react-router-dom";

import {SIGN_IN_URL} from "../config/urls";

export const useSignIn = () => {
    const history = useHistory();

    return async (phoneNumber, password) => {
        try {
            const res = await axios.post(SIGN_IN_URL, {phoneNumber, password}, {});
            localStorage.setItem('token', res.data.token);
            history.replace('/dashboard');
            return true
        } catch (e) {
            return false
        }
    }
};


export const useIsSignedIn = () => {
    const history = useHistory();

    return async () => {
        try {
            if (localStorage.getItem('token'))
                return true;
            history.push('/signin');
            return false
        } catch (e) {
            return false
        }
    }
};

export const useSignOut = () => {
    const history = useHistory();

    return () => {
        try {
            localStorage.removeItem('token');
            history.push('/signin')
        } catch (e) {
            return false
        }
    }
};





